import React, { useEffect, useState } from "react"
import moment from "moment"
import "./WeekView.scss"
import AppointmentCalendarUtils from "../../AppointmentCalenderUtils"
import EachWeekDay from "./components/EachWeekDay"

export default function WeekView({
  includeIpdOpdDivision,
  currentlySelected,
  appointments,
  onButtonClick,
  changeDay,
  outline,
  userRole,
  slots,
  slotDuration,
  bedSlotDuration,
  show
}: any) {
  const [currentWeek, updateCurrentWeek] = useState<any>()

  function getCurrentWeek() {
    let days = AppointmentCalendarUtils.getCurrentWeek(currentlySelected)
    updateCurrentWeek(days)
  }

  useEffect(() => {
    getCurrentWeek()
  }, [currentlySelected])

  function renderWeekdayHeaderSection() {
    return currentWeek?.map((eachDay: any) => (
      <div key={eachDay?.day} className="col">
        <div
          className={`weekday ${AppointmentCalendarUtils.checkCurrentWeekDay(eachDay?.day)
            ? "selected"
            : "not-selected"
            }`}
        >
          <div className="date">{eachDay?.date}</div>
          <div className="day">{eachDay?.day}</div>
        </div>
        {includeIpdOpdDivision && (
          <div className="col-md-12 col-lg-12 m-0 row division">
            <div className="col-md-6 col-lg-6 tab">
              OPD[
              {AppointmentCalendarUtils.fetchCountData(
                appointments,
                eachDay?.totalDate,
                "OPD"
              )}
              ]
            </div>
            <div className="col-md-6 col-lg-6 tab">
              IPD[
              {AppointmentCalendarUtils.fetchCountData(
                appointments,
                eachDay?.totalDate,
                "IPD"
              )}
              ]
            </div>
          </div>
        )}
      </div>
    ))
  }

  function renderEachWeekDay(eachDay: any, eachSlot: any, type: any) {
    return (
      <EachWeekDay
        eachDay={eachDay}
        slot={eachSlot}
        appointments={
          type
            ? appointments?.filter(
              (eachItem: any) =>
                eachItem?.appointmentType?.toLowerCase() ===
                type?.toLowerCase()
            )
            : appointments
        }
        onButtonClick={onButtonClick}
        disablePopup={includeIpdOpdDivision}
        changeDay={changeDay}
        outline={outline}
        userRole={userRole}
        slotDuration={slotDuration}
        bedSlotDuration={bedSlotDuration}
        show={show}
      />
    )
  }

  function renderSlotsView() {
    return (
      <div className="viewer-wrapper">
        {slots?.map((eachSlot: any) => (
          <div key={eachSlot} className="col-md-12 col-lg-12 m-0 row p-0 timeslot">
            <div className="col-md-1 col-lg-1 p-0">
              <div className="timing">{eachSlot}</div>
            </div>
            <div className="col-md-11 col-lg-11 p-0 wrapper">
              <div
                className="border-line-wrapper"
                style={{ position: "absolute", top: "12px" }}
              >
                <div className="border-line" />
              </div>
              <div className="row m-0 col-lg-12 col-md-12 p-0 weekview">
                {currentWeek?.map((eachDay: any) =>
                  includeIpdOpdDivision ? (
                    <div
                      key={`${eachDay?.totalDate}-${eachSlot}`}
                      className="col row m-0"
                    >
                      <div className="col-md-6 col-lg-6 p-0">
                        {renderEachWeekDay(eachDay, eachSlot, "OPD")}
                      </div>
                      <div className="col-md-6 col-lg-6 p-0">
                        {renderEachWeekDay(eachDay, eachSlot, "IPD")}
                      </div>
                    </div>
                  ) : (
                    <div
                      key={`${eachDay?.totalDate}-${eachSlot}`}
                      className="col"
                    >
                      {renderEachWeekDay(eachDay, eachSlot, null)}
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  function renderWeekView() {
    return (
      <div className="weekview-wrapper">
        <div className="col-md-12 row m-0">
          <div className="col-md-1 p-0" />
          <div className="col-md-11 p-0">
            <div className="row m-0 col-md-12 p-0 weekview">
              {renderWeekdayHeaderSection()}
            </div>
          </div>
        </div>

        {renderSlotsView()}
      </div>
    )
  }

  return renderWeekView()
}
